import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=32fbb352&"
import script from "./MoneyInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MoneyInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MoneyInput.vue?vue&type=style&index=0&id=32fbb352&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports